import moment from 'moment';
import isSameDay from 'date-fns-old/is_same_day';
import { isBeforeTime } from '../../../utils/converters/dateConverters';

export const convertVisitTime = (date, time) => {
  const currentDate = moment(date).format('YYYY-MM-DD');
  const formattedTime = moment(time, 'HH:mm A').format('HH:mm');
  return moment(`${currentDate} ${formattedTime}`).format(
    'YYYY-MM-DD HH:mm:ss',
  );
};

function parseTime(timeStr) {
  const [time, interval] = timeStr.split(' ');
  // eslint-disable-next-line prefer-const
  let [hours, minutes] = time.split(':');

  if (
    (interval.toLowerCase() === 'pm' && hours !== '12') ||
    (interval.toLowerCase() === 'am' && hours === '12')
  ) {
    hours = Number(hours) + 12;
  }

  return { hours, minutes };
}

export const convertUTCVisitTime = (date, time) => {
  const { hours, minutes } = parseTime(time);

  return moment(date)
    .startOf('day')
    .add({ minutes, hours })
    .toISOString();
};

export const isValidTime = (time, date) => {
  if (time && date) {
    const visitTime = convertVisitTime(date, time);
    const now = new Date();
    const needValidation = isSameDay(visitTime, now);
    return needValidation ? isBeforeTime(visitTime, now) : false;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/components/VirtualVisit/utils/visitTime.js